import { render, staticRenderFns } from "./AddStep5.vue?vue&type=template&id=57abb482&scoped=true&"
import script from "./AddStep5.vue?vue&type=script&lang=js&"
export * from "./AddStep5.vue?vue&type=script&lang=js&"
import style0 from "./AddStep5.vue?vue&type=style&index=0&id=57abb482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57abb482",
  null
  
)

export default component.exports